import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import languages from '../utils/languages';
import NoPostIcon from '../img/no_post_icon.svg';
import { getPostLanguage } from './../services/authService';

const NoBookmarks = () => {
  const classes = useStyles();
  const webLanguage = getPostLanguage();
  const languageText = languages[webLanguage ? webLanguage : 'en'];
  return (
    <Box bgcolor="#fff" align="center" width="100%" py={27.5} height="60vh">
      <Box>
        <img className={classes.imageSize} src={NoPostIcon} alt="not found" />
      </Box>

      <Box>{languageText?.NO_BOOKMARKS_TO_SHOW}</Box>
    </Box>
  );
};

const useStyles = makeStyles({
  imageSize: {
    width: '120px',
    height: '120px',
    margin: '12px 0 6px 0',
  },
});
export default NoBookmarks;
